export default __webpack_public_path__ + "static/media/bg-company.ba824605.jpg";